var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCourse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 31.42 31.42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".d,.e{fill:none;}.e{stroke:#7c1902;stroke-linejoin:round;stroke-width:1.32px;}.f{fill:#ffaa50;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M15.71,29.71c7.73,0,14-6.27,14-14S23.44,1.71,15.71,1.71,1.71,7.98,1.71,15.71s6.27,14,14,14"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "e",
    points: "11.5 16.99 26.29 2.21 29.71 1.72 29.22 5.14 14.44 19.92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M11.13,20.3c1.58,1.58,2.2,3.19,2.53,5.05l2.8-.9c-.39-2.07-1.53-4.26-3.37-6.1-1.84-1.84-4.03-2.99-6.1-3.37l-.9,2.8c1.86,.32,3.47,.95,5.05,2.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M5.26,29.1c-.81,.81-2.12,.81-2.93,0s-.81-2.12,0-2.93,2.12-.81,2.93,0c.81,.81,.81,2.12,0,2.93Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 3.91,
    y1: 25.56,
    x2: 10.08,
    y2: 19.39
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 5.86,
    y1: 27.52,
    x2: 12.04,
    y2: 21.35
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 6.24,
    y1: 23.23,
    x2: 8.19,
    y2: 25.19
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 8.19,
    y1: 21.28,
    x2: 10.15,
    y2: 23.23
  })), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 31.42,
    height: 31.42
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourse);
export default __webpack_public_path__ + "static/media/course.8ff86821dfe3428ba541d346a4181568.svg";
export { ForwardRef as ReactComponent };